import styled from 'styled-components';

export const ChartWrapper = styled.div``;
export const PriceIndexWrapper = styled.div``;
export const SpendIndexWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin: 5% 0 0 0;
`;

export const LoadingContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
	padding: 10% 0;
`;
